import { Injectable } from '@nestjs/common';
import { EmployeeSkillMatrix } from '../employee-skill-matrix.entity';
import { EmployeeSkillMatrixDTO } from './employee-skill.dto';
import { EmployeeDetails } from '../employee-details.entity';

@Injectable()
export class EmployeeSkillMatrixAdapter {
  public convertEntityToDTO(entity: EmployeeSkillMatrix): EmployeeSkillMatrixDTO {
    const dto = new EmployeeSkillMatrixDTO();
    dto.employeeSkillMatrixId = entity.employeeSkillMatrixId;
    dto.machineWise = entity.machineWise;
    dto.needleType = entity.needleType;
    dto.needleBarAdjustment = entity.needleBarAdjustment;
    dto.hookSetLooperTimings = entity.hookSetLooperTimings;
    dto.stitchingAdjustment = entity.stitchingAdjustment;
    dto.uBTriming = entity.uBTriming;
    dto.feedTiming = entity.feedTiming;
    dto.programSetting = entity.programSetting;
    dto.lubricationSystem = entity.lubricationSystem;
    dto.pullerAssembly = entity.pullerAssembly;
    dto.splitBarMechanism = entity.splitBarMechanism;
    dto.gaugeSetReplacement = entity.gaugeSetReplacement;
    dto.looperThreadTakeUpCamTiming = entity.looperThreadTakeUpCamTiming;
    dto.needleGaurdAdjustment = entity.needleGaurdAdjustment;
    dto.folderAttachementSettingBasic = entity.folderAttachementSettingBasic;
    dto.snapDieFixing = entity.snapDieFixing;
    dto.safetyRequirements = entity.safetyRequirements;
    dto.preventiveMaintenance = entity.preventiveMaintenance;
    dto.OfSkillAquired = entity.OfSkillAquired;
    dto.isActive = entity.isActive;
    dto.createdAt = entity.createdAt;
    dto.createdUser = entity.createdUser;
    dto.updatedAt = entity.updatedAt;
    dto.updatedUser = entity.updatedUser;
    dto.versionFlag = entity.versionFlag;
    // dto.employeeDetails = entity.employeeDetails ? { ...entity.employeeDetails } : null;
    return dto;
  }

  public convertDtoToEntity(req: EmployeeSkillMatrixDTO[]): EmployeeSkillMatrix[] {
    
    const empty = [];
    for (const dto of req) {
      console.log(dto,'dtoooo');
      const entity = new EmployeeSkillMatrix();
      entity.machineWise = dto.machineWise;
      entity.needleType = dto.needleType;
      entity.needleBarAdjustment = dto.needleBarAdjustment;
      entity.hookSetLooperTimings = dto.hookSetLooperTimings;
      entity.stitchingAdjustment = dto.stitchingAdjustment;
      entity.uBTriming = dto.uBTriming;
      entity.feedTiming = dto.feedTiming;
      entity.programSetting = dto.programSetting;
      entity.lubricationSystem = dto.lubricationSystem;
      entity.pullerAssembly = dto.pullerAssembly;
      entity.splitBarMechanism = dto.splitBarMechanism;
      entity.gaugeSetReplacement = dto.gaugeSetReplacement;
      entity.looperThreadTakeUpCamTiming = dto.looperThreadTakeUpCamTiming;
      entity.needleGaurdAdjustment = dto.needleGaurdAdjustment;
      entity.folderAttachementSettingBasic = dto.folderAttachementSettingBasic;
      entity.snapDieFixing = dto.snapDieFixing;
      entity.safetyRequirements = dto.safetyRequirements;
      entity.preventiveMaintenance = dto.preventiveMaintenance;
      entity.OfSkillAquired = dto.OfSkillAquired;
      entity.isActive = dto.isActive;
      entity.createdAt = dto.createdAt;
      entity.createdUser = dto.createdUser;
      entity.updatedAt = dto.updatedAt;
      entity.versionFlag = dto.versionFlag;
      entity.employeeId = dto.employeeId;
      if (dto.employeeSkillMatrixId) {
        entity.employeeSkillMatrixId = dto.employeeSkillMatrixId;
        entity.updatedUser = dto.updatedUser;
      }
      empty.push(entity)
    }

    return empty;
  }
}
